module.exports = __webpack_public_path__ + "static/media/Mail.36cd2dee.svg";